import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Baseservice } from './baseservice';

import { AuthenticationService } from './authentication.service';


@Injectable()
export class PermitTypeVehicleService {
  protected url: string = environment.iCBMSWebApi.url;
  constructor(private http: HttpClient) { }
//permit-type
getAll(){
  return this.http.get(this.url+'permit-type');
}
  getLinkedAndUnlinkedDoctypes(id: number) {
    return this.http.get(this.url + 'permit-type-vehicle-links/' + id);
}

addToLinks(body: any) {

return this.http.post(this.url + 'permit-type-vehicle-links/', body);
}

deleteLink(id: number) {
    return this.http.delete(this.url + 'permit-type-vehicle-links/' + id);
}

updateLink(body: any) {

   return this.http.put(this.url + 'permit-type-vehicle-links/', body);
}
getLinkById(id: number) {
    return this.http.get(this.url + `permit-type-vehicle-links/find/${id}`);
}
getDocTypeLinkByCarrierTypeId(id: number) {
    return this.http.get(this.url + `permit-type-vehicle-links/type/${id}`);
}

}
